module.exports = __webpack_public_path__ + "img/financialIco.fa9b2b79.svg";